// custom elements
/// rebase
import "./components/embla-carousel.js";
import "./components/card-carousel-filters.js";

// standard components
import stickyHeader from "./components/sticky-header.js";
import accordionAria from "./components/accordion-aria.js";
import nestedAccordion from "./components/nested-accordion.js";

// others
import trustPilot from "./components/trustpilot.js";


import "./components/mobile-menu.js";


stickyHeader();
nestedAccordion();

// aria accordion - the whole document needs to be loaded first, otherwise the functions will calculate wrong element heights (showInitialItem())
window.addEventListener("load", (event) => {
  let existingAccordions = [];

  // some mobile devices insert a scrollbar on scroll and then remove it, changing the width and firing the resize event (below is functionality trying to prevent it)
  let windowWidth = window.innerWidth;

  if (document.querySelector(".accordion--product-overview") != null) {
    accordionAria(".accordion--product-overview", {}).init();
    accordionAria(".accordion--product-overview").hideAllItems();
    accordionAria(".accordion--product-overview").showInitialItem();
    existingAccordions.push(".accordion--product-overview");
  }

  if (document.querySelector(".accordion--product-video") !== null) {
    accordionAria(".accordion--product-video", {}).init();
    accordionAria(".accordion--product-video").hideAllItems();
    existingAccordions.push(".accordion--product-video");
  }

  if (document.querySelector(".accordion--product-delivery") !== null) {
    accordionAria(".accordion--product-delivery", {}).init();
    accordionAria(".accordion--product-delivery").hideAllItems();
    existingAccordions.push(".accordion--product-delivery");
  }

  if (document.querySelector(".accordion--product-reviews") !== null) {
    accordionAria(".accordion--product-reviews", {}).init();
    accordionAria(".accordion--product-reviews").hideAllItems();
    accordionAria(".accordion--product-reviews").showInitialItem();
    existingAccordions.push(".accordion--product-reviews");
  }

  if (document.querySelector(".accordion--product-faq") !== null) {
    accordionAria(".accordion--product-faq", {}).init();
    accordionAria(".accordion--product-faq").hideAllItems();
    existingAccordions.push(".accordion--product-faq");
  }

  // aria mobile accordions only
  if (document.querySelector(".accordion--footer-links") !== null) {
    mobileAccordionOnly(".accordion--footer-links");
  }

  if (document.querySelector(".accordion--account-cards") !== null) {
    mobileAccordionOnly(".accordion--account-cards", 990);
  }

  function mobileAccordionOnly(accEl, breakpoint = 750) {
    if (window.innerWidth <= breakpoint) {
      accordionAria(accEl, {}).init();
      accordionAria(accEl).hideAllItems();
      existingAccordions.push(accEl);
    }

    const mediaQueryList = window.matchMedia(`(max-width: ${breakpoint}px)`);

    mediaQueryList.addEventListener("change", (event) => {
      const selectedAcc = document.querySelector(accEl);
      if (selectedAcc !== null && event.matches) {
        accordionAria(accEl, {}).init();
        accordionAria(accEl).hideAllItems();
        existingAccordions.push(accEl);
      } else if (selectedAcc !== null) {
        selectedAcc
          .querySelectorAll(".accordion__content")
          .forEach((content) => (content.style.height = "auto"));
        existingAccordions = existingAccordions.filter((acc) => acc !== accEl);
      }
    });
  }

  window.addEventListener("resize", (e) => {
    if (windowWidth === window.innerWidth) return;
    setTimeout(() => {
      existingAccordions.forEach((acc) => accordionAria(acc).hideAllItems());
      windowWidth = window.innerWidth;
    }, 200);
  });
});

trustPilot();